﻿(function (angular, document, parseInt) {
  "use strict";

  angular.module("Toyota.Directives").directive("tyLazysizesFix", function () {
    var isSafari = /Version\/[\d.]+.*Safari/.test(navigator.userAgent);

    return {
      scope: {
        minWidths: "@tyLazysizesMinWidths",
      },
      link: function (scope, $element) {
        // don't do this if the browser doesn't have the issue to begin with
        if (!isSafari) {
          return;
        }

        var minWidths = scope.minWidths
          .split(" ")
          .map(function (minWidth) {
            return parseInt(minWidth);
          })
          .sort(function (a, b) {
            return a - b;
          });

        var getMinWidthIndex = function () {
          var clientWidth = document.body.clientWidth;
          var i = 0;

          while (minWidths[i + 1] - 1 < clientWidth) {
            i++;
          }

          return i;
        };

        var previousIndex = getMinWidthIndex();

        angular.element(window).on("resize", function () {
          var currentMinWidthIndex = getMinWidthIndex();

          if (currentMinWidthIndex !== previousIndex) {
            previousIndex = currentMinWidthIndex;

            var srcset = $element.attr("srcset");
            $element.attr("srcset", "");
            setTimeout(function () {
              $element.attr("srcset", srcset);
            }, 0);
          }
        });
      },
    };
  });
})(window.angular, window.document, window.parseInt);
